import type { AllRouteEndpoints } from "../routeTypes";
export const openAiLiquidAssistantCacheKeys: AllRouteEndpoints[] = [];
